module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAApBAMAAACmWzYPAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTC07UCw4UC07UC07UC08UC08UCw8UCw8UC08UC08UPq4lM0AAAAKdFJOUwDfI3lb78dAkKqmmFVkAAAAxElEQVQoz2NgAINVq1YtdGBAAkCBVQEMqIBrAWUCIM4wEHAFhc0qAQYGVjBDhEEKRC0FBh8LhMUQZYAcBswLGbyCkAW0ljBwLETiM0k1MDBkTUAIcIJkVRcjBKyEgATLqgK4jlXgyOoSgAkoQhSzLYMJzEqAGm0Ac4QChFG1HJWGycBVAp0C1su2Em494wq4IyCAHWQ/yyoFJBcGwR0B9QPQKVITkL0t1cCxUAFZQHWJ1yKU1MK8FDXkgD5cgZag2GFhAAA1HENi4MZlBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wparrow.png
// module id = D4Hr
// module chunks = 0